import { doc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, store } from "shared/api/firebase";
import { ModuleData, CardBlockImage } from "../types";

type Params = {
  moduleId: string;
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const saveTopPrivacyTipsBlockImage = async ({
  moduleId,
  topPrivacyTipsBlockImage,
}: Params) => {
  try {
    const docRef = doc(db, "moduleTemplates", moduleId);

    const moduleData = (await getDoc(docRef)).data() as ModuleData;

    if (!moduleData.topPrivacyTipsBlock || !topPrivacyTipsBlockImage) {
      return null;
    }

    const path = `moduleTemplates/${moduleId}/top-privacy-tips-block`;
    const imgStorageRef = ref(store, path);

    await uploadBytes(imgStorageRef, topPrivacyTipsBlockImage);

    const updatedBlock = {
      ...moduleData.topPrivacyTipsBlock,
      backgroundImage: path,
    };

    await updateDoc(docRef, {
      topPrivacyTipsBlock: updatedBlock,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving module image:", error);
    throw error; // Or handle it in a way that's appropriate for your app
  }
};
